import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'app/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private _router: Router,
        private _localStorageService: LocalStorageService
    ) {

    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot

    ): Observable<boolean> | boolean {
        if(this._localStorageService.getValue('usuario')){
            return true;
        }
        this._router.navigate(['/login']);
        return false;
    }
}
